import getRequestUrl from "./getRequestUrl";
import getRequestAndHeaders from "./getRequestAndHeaders";

export default async ({ variantId }) => {
  const { request, headers } = await getRequestAndHeaders();
  const requestUrl = getRequestUrl({ variantId });

  request.delete({
    url: requestUrl,
    headers
  });
};
